import messageListCommon from "@/views/messageCommon/MessageListCommon";

export default {
    name: "MessageListPage",
    components: {messageListCommon},
    data() {
        return {
            messageSeq: null
        }
    },
    created() {
        this.messageSeq = this.$route.query.messageSeq
    }

}